import React, { useState, useMemo, useContext } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleQuoteDocumentDetails = () => {
  const { documentId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const decodedId = documentId ? atob(documentId) : documentId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['quoteDocument']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['quoteDocument'] + id + '/', { headers });
      showToast('Quote Document deleted successfully', 'success');
      navigate('/quote/document/list');
    } catch (error) {
      showToast('Error deleting Quote Document', 'error');
      console.error('Error deleting Quote Document:', error);
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Quote Document"
        listPath="/quote/document/list"
        editPath={`/quote/document/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      {showDelete && (
        <ConfirmModal
          isOpen={showDelete}
          onClose={() => setShowDelete(false)}
          onConfirm={handleDelete}
          title="Delete Quote Document"
          message="Are you sure you want to delete this Quote Document? This action cannot be undone."
        />
      )}
    </div>
  );
};

export default SingleQuoteDocumentDetails;
